var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6, _path13, _path14, _g7, _path15, _path16, _g8, _path17, _path18, _g9, _path19, _path20, _g10, _path21, _path22, _g11, _path23, _path24, _g12, _path25, _path26, _g13, _path27, _path28, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 51,
    viewBox: "0 0 105 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.89209 0.480274V33.3773H10.6287V23.0638H21.2667V13.8005H10.7548V9.39644H23.0428L22.9121 0.480274H0.89209Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -10,
    y: -7,
    width: 44,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6123 29.5279L20.4482 -6.64001L-9.68446 4.32741L3.47958 40.4953L33.6123 29.5279Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.34L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 0,
    width: 34,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0111 0.30447L70.2426 7.31394L65.9558 0.30447H54.2314L64.306 15.9957L53.5416 33.3728V33.3773H65.1805L69.9946 26.0839L74.8404 33.3773H86.7406V33.3728L75.6924 16.1129L85.9158 0.30447H74.0111Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: -11,
    width: 56,
    height: 56
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3708 29.5076L82.8578 -10.3665L42.9131 4.17222L57.4261 44.0463L97.3708 29.5076Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.33L690.021 -2668.33L690.021 901.746L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 0,
    width: 38,
    height: 34
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7273 16.8746C22.7273 26.0838 30.8907 33.5485 40.9518 33.5485C51.0265 33.5485 59.1674 26.0838 59.1674 16.8746C59.1674 7.66092 51.0265 0.187141 40.9518 0.187141C30.8907 0.187141 22.7273 7.66092 22.7273 16.8746ZM37.9858 24.6729V9.40987C37.9858 9.40987 37.8596 7.04784 41.0871 7.04784C44.3236 7.04784 44.1207 9.40987 44.1207 9.40987V23.4332C44.1207 25.0244 43.9359 26.3362 40.9518 26.3362C37.9858 26.3362 37.9858 24.6729 37.9858 24.6729Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: -12,
    width: 58,
    height: 58
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8904 29.6449L54.9056 -11.5256L12.006 4.08854L26.9908 45.259L69.8904 29.6449Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.746L-2068.68 -2668.33L690.021 -2668.33L690.021 901.745L-2068.68 901.746Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 0,
    width: 16,
    height: 38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.359 0.304222L99.2766 37.4926H103.73L103.739 37.4881L98.8123 0.304222H88.359Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: -5,
    width: 40,
    height: 48
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.693 33.1416L101.941 -4.64099L76.4035 4.65386L90.1553 42.4364L115.693 33.1416Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.746L-2068.68 -2668.33L690.021 -2668.33L690.021 901.745L-2068.68 901.746Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 4,
    width: 20,
    height: 34
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5548 15.8963L92.0553 37.4926H97.7034L85.8707 4.85702L78.5548 15.8963Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: -2,
    width: 41,
    height: 46
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.193 33.6739L95.4645 -1.29834L68.0671 8.6735L80.796 43.6458L108.193 33.6739Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.34L690.022 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 35,
    width: 90,
    height: 3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.85144 35.3833V37.502H89.1794L87.8496 35.3833H0.85144Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 90,
    height: 60
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8612 37.2528L78.8479 6.9939L0.171379 35.6297L11.1847 65.8887L89.8612 37.2528Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.33L690.021 -2668.33L690.021 901.746L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 39,
    width: 14,
    height: 12
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9428 39.3313V46.9453C26.9428 47.5043 26.776 47.7793 26.4154 47.7793H19.153C18.7923 47.7793 18.6075 47.5043 18.6075 46.9453V39.3313H16.0335H16.0289V46.9453C16.0289 47.8785 16.3174 48.6764 16.8989 49.3481C17.4715 50.0153 18.2198 50.3534 19.153 50.3534H26.4154C27.335 50.3534 28.0744 50.0153 28.665 49.3481C29.251 48.6764 29.535 47.8785 29.535 46.9453V39.3358L26.9428 39.3313Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 34,
    width: 22,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0769 49.0631L27.955 34.9906L12.4878 40.6202L17.6097 54.6927L33.0769 49.0631Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.34L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 39,
    width: 14,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3078 39.3313C33.3972 39.3313 32.6398 39.6649 32.0673 40.3321C31.4858 41.0083 31.1884 41.8107 31.1884 42.7349C31.1884 43.668 31.4723 44.457 32.0493 45.1061C32.6398 45.7823 33.3972 46.1249 34.3078 46.1249H41.2097C41.5613 46.1249 41.7506 46.4044 41.7506 46.9499C41.7506 47.5044 41.5613 47.7793 41.2097 47.7793H31.7248V50.3534H41.2097C42.1248 50.3534 42.8821 50.0108 43.4726 49.3256C44.0361 48.6719 44.3067 47.8785 44.3067 46.9499C44.3067 46.0348 44.0361 45.2323 43.4726 44.5831C42.8821 43.8934 42.1248 43.5553 41.2097 43.5553H34.3078C33.9562 43.5553 33.7669 43.2804 33.7669 42.7349C33.7669 42.1849 33.9562 41.9054 34.3078 41.9054H43.7882V39.3313H34.3078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 35,
    width: 21,
    height: 20
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8487 49.0632L42.7721 35.1152L27.6469 40.6203L32.7235 54.5683L47.8487 49.0632Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.33L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 39,
    width: 4,
    height: 12
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6668 39.3313L45.6624 50.3534H48.2274L48.2364 50.3489V39.3313H45.6668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 38,
    width: 10,
    height: 14
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.78 49.0637L47.9364 38.5035L42.1207 40.6203L45.9642 51.1804L51.78 49.0637Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.34L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 39,
    width: 13,
    height: 12
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0464 39.3313V46.7064L52.4422 39.3313H49.8726H49.868V50.3534H52.4422V42.9287L59.0464 50.3534H61.6024H61.607V39.3313H59.0464Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 35,
    width: 20,
    height: 20
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1492 49.0629L60.2339 35.5583L46.3267 40.6202L51.242 54.1247L65.1492 49.0629Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.33L690.021 -2668.33L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 39,
    width: 12,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2512 39.3313L63.2468 50.3534H74.9632V47.7793H65.8163V46.1249H74.3817V43.5553H65.8163V41.9054H74.9812V39.3313H63.2512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 35,
    width: 20,
    height: 20
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5233 49.0629L73.6085 35.5598L59.7055 40.6201L64.6202 54.1232L78.5233 49.0629Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.746L-2068.68 -2668.33L690.021 -2668.33L690.021 901.746L-2068.68 901.746Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 39,
    width: 14,
    height: 12
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7451 39.3313C78.8345 39.3313 78.0951 39.6649 77.5046 40.3321C76.9185 41.0083 76.6255 41.8107 76.6255 42.7349C76.6255 43.668 76.9095 44.457 77.4866 45.1061C78.0816 45.7823 78.8345 46.1249 79.7451 46.1249H86.6468C86.9984 46.1249 87.1833 46.4044 87.1833 46.9499C87.1833 47.5044 86.9984 47.7793 86.6468 47.7793H77.1619V50.3534H86.6559C87.562 50.3534 88.3283 50.0108 88.9279 49.3256C89.4734 48.6719 89.7529 47.8785 89.7529 46.9499C89.7529 46.0348 89.4734 45.2323 88.9279 44.5831C88.3238 43.8934 87.562 43.5553 86.6559 43.5553H79.7451C79.3845 43.5553 79.204 43.2804 79.204 42.7349C79.204 42.1849 79.3845 41.9054 79.7451 41.9054H89.2344V39.3313H79.7451Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 35,
    width: 21,
    height: 20
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2949 49.0631L88.2173 35.1123L73.0844 40.6202L78.1621 54.571L93.2949 49.0631Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.34L690.021 901.744L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 39,
    width: 14,
    height: 12
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2147 39.3313C93.3131 39.3313 92.5783 39.6649 91.9787 40.3321C91.4062 41.0083 91.0996 41.8107 91.0996 42.7349C91.0996 43.668 91.3927 44.457 91.9427 45.1061C92.5603 45.7823 93.3131 46.1249 94.2147 46.1249H101.13C101.482 46.1249 101.671 46.4044 101.671 46.9499C101.671 47.5044 101.482 47.7793 101.13 47.7793H91.6451V50.3534H101.13C102.036 50.3534 102.793 50.0108 103.393 49.3256C103.956 48.6719 104.227 47.8785 104.227 46.9499C104.227 46.0348 103.956 45.2323 103.393 44.5831C102.793 43.8934 102.036 43.5553 101.13 43.5553H94.2147C93.8676 43.5553 93.6872 43.2804 93.6872 42.7349C93.6872 42.1849 93.8676 41.9054 94.2147 41.9054H103.709V39.3313H94.2147Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 35,
    width: 21,
    height: 20
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.769 49.0631L102.692 35.1123L87.5583 40.6204L92.6359 54.5711L107.769 49.0631Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.34L690.021 -2668.33L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 39,
    width: 15,
    height: 12
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0.905418 39.3322H0.900879V50.3534H0.905418H11.5706C12.5397 50.3534 13.3061 50.0469 13.8786 49.4113C14.406 48.8523 14.6719 48.1492 14.6719 47.3152C14.6719 46.1793 14.2122 45.3228 13.3151 44.7684C14.0815 44.1959 14.4601 43.3936 14.4601 42.3703C14.4601 41.5409 14.1986 40.8422 13.6757 40.2743C13.1122 39.6477 12.3369 39.3322 11.3813 39.3322H0.905418ZM3.47483 41.906H11.3813C11.7509 41.906 11.9313 42.19 11.9313 42.7445C11.9313 43.3034 11.7509 43.5874 11.3813 43.5874H3.47483V41.906ZM3.47483 46.1252H11.5706C11.9402 46.1252 12.134 46.4047 12.134 46.9501C12.134 47.5046 11.9402 47.7795 11.5706 47.7795H3.47483V46.1252Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_354_39996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_354_39996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 34,
    width: 22,
    height: 21
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.215 49.0631L13.062 34.9053L-2.64024 40.6204L2.51277 54.7782L18.215 49.0631Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_354_39996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2068.68 901.745L-2068.68 -2668.33L690.021 -2668.33L690.021 901.745L-2068.68 901.745Z",
    fill: "#A7A7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/fox.0e9dbfca794c8d8d5ed45fadd8a32c53.svg";
export { ForwardRef as ReactComponent };